define('collections/questionnaire/options/options',[
    'underscore',
    'backbone',
    'utils',
    // services
    'services/api',
    // model
    'models/questionnaire/option'
], function(
    _, Backbone, U,
    // services
    API,
    // model
    MOption
) {

    var COptions = Backbone.Collection.extend({
        model: MOption,

    });

    return COptions;

});

